import React from 'react';

import TextShortenIcon from '@atlaskit/icon/core/text-shorten';

export const MakeShorterIcon = (): React.JSX.Element => (
	<TextShortenIcon label="" color="currentColor" spacing="spacious" />
);
